import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AbstractLocalStorageService } from 'src/app/moov-common/services/localStorage/local-storage.abstract.service';
import { LocalStorageKeys } from 'src/app/moov-common/services/localStorage/local-storage.enum';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { NAVIGATION_ROUTES } from 'src/app/navigation-routes.const';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService  {
  constructor(public router: Router, public localStorageService: AbstractLocalStorageService, public personalUserDataService: AbstractPersonalUserDataService) { }
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // console.log(` RoleGuardService user role ${this.personalUserDataService.getLoggedInUserPersonalData()?.role}`);

    const allowedRoles = route.data.roles as Array<number>;

    // console.log (`RoleGuard allowedRoles ${allowedRoles} user role is ${this.personalUserDataService.getLoggedInUserPersonalData()?.role}`);
    const userDetails = this.personalUserDataService.getLoggedInUserPersonalData();


    if (userDetails == undefined || !allowedRoles.includes(userDetails.role)) {
      this.localStorageService.write<string>(LocalStorageKeys.returnUrl, state.url);

            this.router.navigate([NAVIGATION_ROUTES.app.personalView], { state: { redirect: state.url } });
      return false;
    } else {
      // console.log(`Guard return true`);
      return true;  
    }
    
  }}
